import type { ReactNode } from "react";

type ToolbarProps = {
  children: ReactNode;
  className?: string;
  /** Visually group related actions */
  label?: string;
};

export function Toolbar({ children, className, label }: ToolbarProps) {
  return (
    <div className={`toolbar ${className ?? ""}`.trim()} role="group" aria-label={label}>
      {children}
    </div>
  );
}

export function ToolbarGroup({ children }: { children: ReactNode }) {
  return <div className="toolbar-group">{children}</div>;
}

export function ToolbarSpacer() {
  return <div className="toolbar-spacer" aria-hidden="true" />;
}
